import axios from 'axios'

import moment from 'moment'
import 'moment/locale/it'
moment.locale('it')

export const createTransferOrder = ({ transferOrder, token }) => {
  return axios({
    method: 'post',
    url: `${process.env.REACT_APP_BACKEND_ENDPOINT}/api/transfer-order`,
    data: transferOrder,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  })
}

export const sendEmail = ({
  transferOrders,
  emailSubject,
  emailBody,
  token,
  cc,
}) => {
  return axios({
    method: 'post',
    url: `${process.env.REACT_APP_BACKEND_ENDPOINT}/api/email/send`,
    data: {
      transferOrders: transferOrders.sort((a, b) =>
        Math.sign(a.warehouseId - b.warehouseId),
      ),
      emailBody,
      emailSubject,
      cc,
    },
    headers: {
      Authorization: `Bearer ${token}`,
    },
  })
}

// const createTransferOrders = ({ transferOrders, token }) => {
//   return Promise.all(
//     transferOrders.map(transferOrder =>
//       createTransferOrder({ ...transferOrder, token }),
//     ),
//   )
// }

/**
 * @param {number} isoWeekday - The target day of the week, 1 (Monday) to 5 (Friday).
 * @param {moment.Moment} [from] - The moment to search forward from. Defaults to now.
 * @returns {moment.Moment} - The first occurrence of isoWeekday strictly after `from`.
 *   Strictly, so that a delivery day can never resolve to the pickup date itself.
 */
export const getNextWeekday = (isoWeekday, from = moment()) =>
  from.isoWeekday() >= isoWeekday
    ? from.clone().isoWeekday(isoWeekday + 7)
    : from.clone().isoWeekday(isoWeekday)

export const getEmailFields = ({
  transferOrders,
  storeName,
  when,
  time,
  cc,
  shippingCurrier,
  to,
  isFromStore,
  storeFromName,
  pickUpDay,
  pickUpTime,
  apparelAdditionalCare,
  deliveryNote,
  packingListNote,
}) => {
  const pickUpDate = pickUpDay && getNextWeekday(pickUpDay)
  const deliveryDate = when && getNextWeekday(when, pickUpDate || moment())
  const pickUpText = pickUpDate
    ? `Ritiro ${pickUpTime ? `${pickUpTime} del ` : ''}${pickUpDate.format(
        'D MMMM YYYY',
      )}.`
    : ''
  const deliverySentence = [
    time,
    deliveryDate && `del ${deliveryDate.format('D MMMM YYYY')}`,
    shippingCurrier && `con ${shippingCurrier}`,
  ]
    .filter(Boolean)
    .join(' ')
  const deliveryText = [
    deliverySentence && `Consegna ${deliverySentence}.`,
    deliveryNote,
  ]
    .filter(Boolean)
    .join(' ')
  return transferOrders.length
    ? {
        to: to ? to : process.env.REACT_APP_TRANSFER_ORDER_MAIL_TO,
        cc: `${process.env.REACT_APP_TRANSFER_ORDER_MAIL_CC}${
          process.env.NODE_ENV === 'production' ? `,${cc}` : ''
        }`,
        subject: `${
          isFromStore ? `Trasferimento` : `Rifornimento`
        } ${storeName} ${moment().format('DD/MM/YYYY')}`,
        body: `Ciao ${isFromStore ? storeFromName : 'Renzo'},

${transferOrders
  .map(
    ({ id, warehouseName }) =>
      `L'ordine ${id} ${
        isFromStore
          ? `è per il ${storeName}`
          : `è per prodotti ${warehouseName}`
      }`,
  )
  .join('\n')}

${
  isFromStore
    ? `
Il ritiro è previsto per domani, @CS: ci potresti mandare la lettera di vettura?`
    : [pickUpText, deliveryText].filter(Boolean).join('\n')
}
${apparelAdditionalCare ? apparelAdditionalCare : ''}
${
  !isFromStore
    ? `
In aggiunta, servirebbero:
  [INSERIRE AGGIUNTE QUI]
${packingListNote ? `\n${packingListNote}\n` : ''}`
    : ''
}
Grazie`,
      }
    : {}
}
